
function snackbar(msg, action) {
    if (snackbar.setMessage) {
        snackbar.setMessage(msg, action);
    }
}

export default snackbar;